import { a as getUsersByEmail, g as get, L as LicenseCollection, I as InstallerCollection } from "../../../../chunks/firebase.js";
import admin from "firebase-admin";
const Timestamp = admin.firestore.Timestamp;
const load = async ({ locals, depends }) => {
  if (locals.user) {
    const deviceQuery = await getUsersByEmail(locals.user.email);
    const license = await get(LicenseCollection(), locals.user.email);
    const installer = await get(InstallerCollection(), locals.user.email);
    if (license.data) {
      let licenseIssuedOn = license.data.issuedOn || license.doc.createTime;
      const devices = deviceQuery.docs.map((doc) => doc.data()?.id);
      let installerInfo = installer.data;
      if (installer.data?.cancelled) {
        installerInfo = void 0;
      }
      if (licenseIssuedOn instanceof Timestamp) {
        licenseIssuedOn = licenseIssuedOn.toDate();
      }
      return {
        license: {
          ...license.data,
          issuedOn: licenseIssuedOn
        },
        installer: installerInfo,
        devices
      };
    }
  }
  return {};
};
export {
  load
};
